//------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by d2-i18n-generate.
//
// Changes to this file may cause incorrect behavior and will be lost if
// the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import i18n from '@dhis2/d2-i18n';
import arTranslations from './ar/translations.json';
import csTranslations from './cs/translations.json';
import enTranslations from './en/translations.json';
import esTranslations from './es/translations.json';
import kmTranslations from './km/translations.json';
import loTranslations from './lo/translations.json';
import nbTranslations from './nb/translations.json';
import nlTranslations from './nl/translations.json';
import ukTranslations from './uk/translations.json';
import uz_UZ_CyrlTranslations from './uz_UZ_Cyrl/translations.json';
import zhTranslations from './zh/translations.json';
const namespace = 'default';
i18n.addResources('ar', namespace, arTranslations);
i18n.addResources('cs', namespace, csTranslations);
i18n.addResources('en', namespace, enTranslations);
i18n.addResources('es', namespace, esTranslations);
i18n.addResources('km', namespace, kmTranslations);
i18n.addResources('lo', namespace, loTranslations);
i18n.addResources('nb', namespace, nbTranslations);
i18n.addResources('nl', namespace, nlTranslations);
i18n.addResources('uk', namespace, ukTranslations);
i18n.addResources('uz_UZ_Cyrl', namespace, uz_UZ_CyrlTranslations);
i18n.addResources('zh', namespace, zhTranslations);
export default i18n;